import { Link } from "react-router-dom";

export default function ContactCta() {
  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-6 py-12 text-center md:px-16 md:py-16">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20coral%20abstract%20anime%20sparkle%20and%20speed%20line%20background%2C%20soft%20glowing%20bokeh%20lights%2C%20energetic%20manga%20energy%20burst%2C%20no%20text%2C%20vibrant%20warm%20gradient%2C%20clean%20and%20expressive&width=1600&height=700&seq=papaya-cta-01&orientation=landscape"
            alt="番木瓜漫画 联系我们背景"
            className="absolute inset-0 h-full w-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 to-primary-900/50"></div>

          <div className="relative z-10">
            <h2 className="font-heading text-2xl text-background-50 md:text-4xl">
              追更路上，番木瓜漫画陪你同行
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-background-100/90 md:text-base">
              无论你想推荐新作、反馈建议，还是有任何追更问题，欢迎随时联系我们，一起把喜欢的故事分享给更多人。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="flex w-full items-center justify-center rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600 whitespace-nowrap sm:w-auto"
              >
                联系我们
                <i className="ri-mail-send-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="flex w-full items-center justify-center rounded-full border border-background-100/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition hover:bg-background-50/20 whitespace-nowrap sm:w-auto"
              >
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}